// extracted by mini-css-extract-plugin
module.exports = {"container":"Title_container__ln_m9","lineContainer":"Title_lineContainer__3eVAQ","fixedWidth":"Title_fixedWidth__Pg37m","center":"Title_center__19981"};